import vSelect from 'vue-select';
import Vue from 'vue';
import App from './App.vue';
import 'vue-select/dist/vue-select.css';
import router from './router';

Vue.config.productionTip = false;
Vue.component('v-select', vSelect);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
